<template>
  <div
    class="snippet-picker-list"
    data-test="graphics-snippetPicker"
  >
    <div class="snippet-filter">
      <input
        v-model="filter"
        class="tb-input"
        type="text"
        placeholder="Filter snippets"
        data-test="graphics-snippetPickerFilter"
        data-entity="graphics-snippetPickerFilter"
      >
    </div>

    <ul
      v-if="hasSnippets"
      class="snippet-items"
      aria-role="listbox"
      data-test="graphics-snippetPickerItems"
    >
      <li
        v-for="(snippet, index) in filteredSnippets"
        :key="index"
        aria-role="option"
        class="snippet-item"
        data-test="graphics-selectSnippet"
        data-entity="graphics-selectSnippet"
        @click.stop="chooseSnippet(snippet)"
      >
        <span class="snippet-title">{{ snippet.title }}</span>
      </li>
    </ul>

    <div
      v-else
      class="info-box text-xsmall"
      data-test="graphics-snippetPickerNoSnippets"
    >
      No snippets found.
    </div>
  </div>
</template>

<script>
import { filter } from 'lodash-es';

export default {
  emits: ['hide', 'snippet'],
  data() {
    return {
      selected: null,
      filter: '',
    };
  },
  computed: {
    filteredSnippets() {
      const val = $.trim(this.filter).replace(/ +/g, ' ').toLowerCase();

      const filtered = filter(
        this.$store.state.user.snippets,
        (snippet) => {
          const text = snippet.title.replace(/\s+/g, ' ').toLowerCase();
          // TODO: refactor bitwise: tried refactoring away from the bitwise, but it broke things
          // so punting this for now because it doesn't really matter to state update.
          // eslint-disable-next-line no-bitwise
          return ~text.indexOf(val);
        },
      );

      return filtered;
    },
    hasSnippets() {
      return this.filteredSnippets.length > 0;
    },
  },
  mounted() {
    const self = this;

    $('body').on('click', (evt) => {
      if (evt.target !== self.$el && !self.$el.contains(evt.target)) {
        self.$emit('hide');
      }
    });
  },
  methods: {
    chooseSnippet(snippet) {
      this.filter = '';
      this.$emit('snippet', snippet);
    },
  },
};
</script>
